import styled, { css, keyframes } from "styled-components";

const positionUp = keyframes`
   0%{
    animation-timing-function: cubic-bezier(0.17,0.17,0,1);
    transform: translateY(30px);  
       }
  
  100%{
    transform: translateY(0);     }
  } 
`;

const opacityUp = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0.5,0,0,1);
    opacity:0;  }
  100%{
    opacity:1;  
  } 
`;
const fadeInAfterAuto = css`
  ${positionUp} 600ms 1 forwards, ${opacityUp} 217ms 1 forwards
`;
export const TextD = styled.div`
  text-align: center;
  color: #413f62;
  font-size: 20px;
  margin-bottom: 18px;
  margin-top: ${(p) => (p.isAutoOn ? "50px" : 0)};
  animation: ${(p) => (p.fadeInAfterAuto ? fadeInAfterAuto : null)};
  height: 50px;
`;

export const AfterBetP = styled.p`
  ${(w) => (w.w > 0 ? "color: #ffb000" : "color: #413f62")};
  animation: ${css`
    ${positionUp} 383ms 1 forwards, ${opacityUp} 133ms 1 forwards
  `};
  animation-delay: ${(p) => p.delay};
  opacity: 0;
  font-size: 20px;
  svg {
    width: 15px !important;
    height: 15px !important;
    path {
      ${(w) => (w.w > 0 ? "fill: #ffb000" : "fill: #413f62")};
    }
  }
`;
